import React, { useEffect, useState } from "react";
import axios from "axios";
import McpTokensSection from "../components/McpTokensSection";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Billing() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const load = async () => {
    try {
      const r = await axios.get(`${API}/billing/me`, { withCredentials: true });
      setData(r.data);
    } catch (e) { setErr(e?.response?.data?.detail || "Failed to load billing"); }
  };
  useEffect(() => { load(); }, []);

  const upgrade = async () => {
    setBusy(true); setErr(null);
    try {
      const r = await axios.post(`${API}/billing/checkout`, {}, { withCredentials: true });
      window.location.href = r.data?.checkout_url;
    } catch (e) { setErr(e?.response?.data?.detail || "Failed"); setBusy(false); }
  };
  const manage = async () => {
    setBusy(true); setErr(null);
    try {
      const r = await axios.post(`${API}/billing/portal`, {}, { withCredentials: true });
      window.location.href = r.data?.portal_url;
    } catch (e) { setErr(e?.response?.data?.detail || "Failed"); setBusy(false); }
  };

  if (!data) return <div className="p-8 text-sm text-zinc-500">Loading…</div>;
  const isPro = data.tier === "pro" && ["active", "trialing"].includes(data.subscription_status);

  return (
    <div className="max-w-2xl mx-auto px-4 py-8" data-testid="billing-page">
      <div className="text-[10px] uppercase font-mono text-zinc-500">Account</div>
      <h1 className="text-2xl font-semibold tracking-tight text-zinc-900 mt-1">Billing</h1>

      <div className="mt-6 border border-zinc-200 rounded-lg p-5 bg-white">
        <div className="flex items-baseline justify-between">
          <div>
            <div className="text-[10px] uppercase font-mono text-zinc-500">Current plan</div>
            <div className="mt-1 text-lg font-semibold text-zinc-900">
              {isPro ? "HCRIS+ Pro" : "Free"}
            </div>
          </div>
          <div className={`text-[10px] font-mono px-2 py-0.5 rounded uppercase ${
            isPro ? "bg-emerald-100 text-emerald-800" : "bg-zinc-100 text-zinc-600"
          }`} data-testid={isPro ? "tier-badge-pro" : "tier-badge-free"}>
            {data.tier}{data.subscription_status ? ` · ${data.subscription_status}` : ""}
          </div>
        </div>
        {data.current_period_end && (
          <div className="mt-3 text-xs font-mono text-zinc-600">
            {data.cancel_at_period_end ? "Cancels" : "Renews"} on {new Date(data.current_period_end).toLocaleDateString()}
          </div>
        )}
        <div className="mt-5 flex gap-2">
          {isPro ? (
            <button onClick={manage} disabled={busy}
                    className="px-4 py-2 rounded bg-zinc-900 hover:bg-zinc-800 disabled:opacity-50 text-white text-sm font-mono uppercase tracking-wider"
                    data-testid="billing-manage-btn">
              {busy ? "…" : "Manage subscription"}
            </button>
          ) : (
            <button onClick={upgrade} disabled={busy}
                    className="px-4 py-2 rounded bg-emerald-700 hover:bg-emerald-800 disabled:opacity-50 text-white text-sm font-mono uppercase tracking-wider"
                    data-testid="billing-upgrade-btn">
              {busy ? "…" : "Upgrade to Pro · $99/mo"}
            </button>
          )}
        </div>
        {err && <div className="mt-3 text-xs text-red-700 font-mono">{err}</div>}
      </div>

      <div className="mt-6 text-[11px] font-mono text-zinc-500">
        Email: <span className="text-zinc-700">{data.email}</span>
        {data.stripe_customer_id && <> · Stripe customer: <span className="text-zinc-700">{data.stripe_customer_id}</span></>}
      </div>

      <McpTokensSection isPro={isPro} />
    </div>
  );
}
